function valuesArray({ array, key }) {
  const set = new Set();
  array.forEach((item) => {
    set.add(item[key]);
  });

  return Array.from(set);
}

function specialCommand(command) {
  const cmd = Buffer.from(JSON.stringify(command)).toString('base64');

  return cmd;
}

function formData(object) {
  const data = new FormData();
  Object.entries(object).forEach(
    ([key, value]) => data.append(key, value),
  );

  return data;
}

function deepCopy(object) {
  return JSON.parse(
    JSON.stringify(object),
  );
}

function timestamp() {
  return new Date().getTime();
}

function characterLength(str) {
  const regex = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g;
  return str.replace(regex, 'mm').length;
}

export default {
  valuesArray,
  specialCommand,
  deepCopy,
  formData,
  timestamp,
  characterLength,
};
